import { useEffect } from 'react';
import axios from 'axios';

const BASE = import.meta.env.VITE_API_URL || 'https://api.fittrack.site/api';

// Shared across pages so moving between Login and Register doesn't ping twice.
let wakePromise: Promise<void> | null = null;
let wakeStartedAt = 0;

/**
 * Resolves once the backend answers /health (or gives up), never rejects.
 * A sleeping host wakes on the first request; callers await this before
 * submitting so the real request lands on a warm server instead of timing
 * out. Users never see a "server is waking up" notice. On a cold start the
 * submit button just stays busy a little longer.
 */
export function waitForServer(): Promise<void> {
  // Re-ping if the last successful check is old; the host may have slept again.
  if (!wakePromise || Date.now() - wakeStartedAt > 5 * 60_000) {
    wakeStartedAt = Date.now();
    wakePromise = axios
      .get(`${BASE}/health`, { timeout: 60000 })
      .then(() => undefined, () => undefined);
  }
  return wakePromise;
}

/** Starts waking the backend silently as soon as the page mounts. */
export function useServerWake(): void {
  useEffect(() => {
    void waitForServer();
  }, []);
}
